//libs
import React, { memo } from 'react';

//types
import { AccordionProps } from './types';

// helpers
import { saveAnalytics } from 'shared/components/Footer/helpers';

//icon
import IconChevron from '@nykaa/ui-components/Icons/chevron-down';

// styles
import { StyledAccordion, SectionHeading } from './styles';

//constants
import { ICON_SIZES } from 'shared/components/Footer/constants';
const Accordion = ({ heading, links, isHorizontal }: AccordionProps) => {
  const onClick = (e: MouseEvent) => {
    e.preventDefault();
    saveAnalytics();
    window.location.href = e.target?.href;
  };
  return (
    <>
      <SectionHeading>{heading}</SectionHeading>
      {links.map((cat, idx) => {
        return (
          <StyledAccordion key={`accordion-${heading}-${links.length + idx}`}>
            <input
              type="checkbox"
              name="acc-input"
              id={`acc-${heading}-${idx}`}
              className="acc-input"
            />

            <label className="acc-title" htmlFor={`acc-${heading}-${idx}`}>
              {cat.title}
              <IconChevron size={ICON_SIZES.MWEB} className="expander" />
            </label>

            <ul className={`acc-list ${isHorizontal ? 'horizontal-list' : ''}`}>
              {cat.links.map((link, indx) => (
                <li className="acc-item" key={`${link.text}-${indx}`}>
                  <a className="acc-anc" href={link.href} onClick={onClick} target="_self">
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </StyledAccordion>
        );
      })}
    </>
  );
};

export default memo(Accordion);
